import headerTemplate from './configuratorHeader.html';
import './configuratorHeader.scss';

const header = () => ({
    template: headerTemplate,
    scope: {
        isApiValue: '&?',
        productInfo: '=',
        editProduct: '<',
        editSource: '<',
        isMobile: '<',
    },
    controller: 'ConfiguratorHeaderCtrl',
    controllerAs: 'confHeader',
    bindToController: true
});

export default header;
